import React from "react";
import Components from "./Components";

function App() {
  return <Components />;
}

export default App;
